module.exports = __webpack_public_path__ + "static/media/GlossaryIcon.4e26e539.svg";